module.exports = __webpack_public_path__ + "img/of_ic_order_user@2x.55f1dfbc.png";